<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="rowInfo.id===''?'添加司机':'编辑司机'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="driverName">
              <el-input v-model="rowInfo.driverName" placeholder="姓名" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="rowInfo.idCard" placeholder="身份证号" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <select-text v-model="rowInfo.gender" code-set-id="1001" placeholder="性别" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="rowInfo.phone" placeholder="电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="加盟城市" prop="joinCityCode">
              <select-city v-model="rowInfo.joinCityCode" placeholder="加盟城市" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
           <el-form-item label="加盟日期">
             <el-date-picker
               v-model="rowInfo.joinDate"
               type="date"
               placeholder="加盟日期"
               value-format="yyyy-MM-dd"
               style="width: 220px">
             </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属项目" prop="projectId">
              <select-text v-model="rowInfo.projectId" :multiple="true" code-set-id="" :options="projectOptions"  placeholder="所属项目" style="width: 220px;"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属车队" prop="company">
              <el-input v-model="rowInfo.company" placeholder="所属车队" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否公海" prop="isHighSeas">
              <select-text v-model="rowInfo.isHighSeas" code-set-id="1006"  placeholder="是否公海" style="width: 220px;"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
           <el-form-item label="联系地址">
              <el-input v-model="rowInfo.address" placeholder="联系地址" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
         <el-col :span="12">
            <el-form-item label="车牌号" prop="plateNumber">
              <el-input v-model="rowInfo.plateNumber" placeholder="车牌号" style="width: 220px"/>
            </el-form-item>
          </el-col>
         <el-col :span="12">
           <el-form-item label="车型">
              <el-input v-model="rowInfo.vehicleBrand" placeholder="车型" style="width: 220px"/>
            </el-form-item>
         </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆颜色" prop="vehicleColor">
              <el-input v-model="rowInfo.vehicleColor" placeholder="车辆颜色" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆照片" prop="vehiclePhotos">
                 <img-upload
                     @handleUploadSuccess="handleUploadSuccess"
                     v-model="rowInfo.vehiclePhotos"
                     :url="rowInfo.vehiclePhotosUrl"
                 />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证正面" prop="idCardFront">
             <img-upload
               v-model="rowInfo.idCardFront"
               :url="rowInfo.idCardFrontUrl"
             />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="驾驶证正面" prop="driverLicenseFront">
             <img-upload
               v-model="rowInfo.driverLicenseFront"
               :url="rowInfo.driverLicenseFrontUrl"
             />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="行驶证正面" prop="drivingLicenseFront">
             <img-upload
               v-model="rowInfo.drivingLicenseFront"
               :url="rowInfo.drivingLicenseFrontUrl"
             />
            </el-form-item>
          </el-col>
          <el-col :span="12">
           <el-form-item label="行驶证反面">
               <img-upload
                 v-model="rowInfo.drivingLicenseReverse"
                 :url="rowInfo.drivingLicenseReverseUrl"
               />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import SelectText from '@/components/SelectText/index.vue'
import SelectCity from '@/components/SelectCity/index.vue'
import ImgUpload from '@/components/ImgUpload/index.vue'
import { addListpage,getDynamicFormValue } from  "@/api/driver/driverinfo"
import { citys } from  "@/const/city"
import { mapGetters } from 'vuex';
import {loadProjectList} from "@/api/project";
export default {
  components: {
    SelectText,SelectCity,ImgUpload
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    // 手机号
    let validatePhone = (rule, value, callback) => {
      let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的电话'))
      }
      callback()
    }
    let validateEmail = (rule, value, callback) => {
      let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      }
      callback()
    }
    return {
      visible: false,
      formName: '新增',
      uploadUrl: process.env.VUE_APP_BASE_API + '/attach/upload',
      loading: false,
      projectOptions:[],
      rowInfo: {
        id: ''
      },
      rules: {
        driverName: [{ required: true, message: '必填:姓名', trigger: 'blur' }],
        idCard: [{ required: true, message: '必填:身份证号', trigger: 'blur' }],
        /*gender: [{ required: true, message: '必填:性别', trigger: 'change' }],*/
        /*birthday: [{ required: true, message: '必填:出生日期', trigger: 'change' }],*/
        joinCityCode: [{ required: true, message: '必填:加盟城市', trigger: 'blur' }],
        plateNumber: [{ required: true, message: '必填:车牌号', trigger: 'blur' }],
        vehiclePhotos: [{ required: true, message: '必填:车辆照片', trigger: 'change' }],
        idCardFront: [{ required: true, message: '必填:身份证正面', trigger: 'change' }],
       /* idCardReverse: [{ required: true, message: '必填:身份证反面', trigger: 'change' }],*/
        driverLicenseFront: [{ required: true, message: '必填:驾驶证正面', trigger: 'change' }],
        drivingLicenseFront: [{ required: true, message: '必填:行驶证正面', trigger: 'change' }],
        isHighSeas: [{ required: true, message: '必填:是否公海', trigger: 'change' }],
        phone: [
          { required: true, message: '必填:电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {

  },
  methods: {
    init(id) {
      this.visible = true
      this.rowInfo.id = id
      if (id) {
        getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
            }
        })
      }
      this.loadProjectList()
    },
    loadProjectList(){
      loadProjectList().then(res => {
        this.projectOptions = res.data.data
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(citys!=null&&citys.length>0){
            for(var i=0;i<citys.length;i++){
              if(citys[i].codeItemId==this.rowInfo.joinCityCode){
                this.$set(this.rowInfo,'joinCity',citys[i].codeName)
                break;
              }
            }
          }
          addListpage(this.rowInfo).then((res) => {
            if (res.data.code==0) {
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id: ''
      }
    },
    handleUploadSuccess(res) {
      //
    },
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
